import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    CHECKBOX_LEFT: "9px",
    TREE_ITEM_PADDING_LEFT: "13px"
};
export default {
    MenuWrapper: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["marginSize"], prop)
    }) `
    height: inherit;
    overflow: hidden;
    .dx-treeview-search {
      margin: ${({ marginSize }) => (marginSize ? `${marginSize}em` : "0")};
    }

    .dx-treeview-node-container {
      .dx-checkbox {
        left: ${SIZES.CHECKBOX_LEFT};
      }
    }
    .dx-treeview-toggle-item-visibility {
      margin-right: ${SIZES.TREE_ITEM_PADDING_LEFT};
    }

    .dx-treeview-item {
      padding-left: ${SIZES.TREE_ITEM_PADDING_LEFT};

      .dx-treeview-item-content {
        > span {
          font-size: ${({ theme }) => theme["font-size-base"]};
          border-radius: ${({ theme }) => theme["border-radius-base"]};
          text-decoration: none;
          width: calc(100% - 20px);
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  `
};
